import React from 'react';
import styles from './style.module.scss';

interface AlertProps {
  message: string;
  onClose: () => void;
}

export const Alert: React.FC<AlertProps> = ({ message, onClose }) => {

  return (
    <div className={`${styles.alert} ${styles.error}`}>
      <span>{message}</span>
      <button onClick={onClose} className={styles['close-button']}>&times;</button>
    </div>
  );

};
